@if (isBusy) {
    <ws-busy-indicator [message]="busyMessage"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Appeal Forms"
                  subHeaderLabel="Check the forms you wish to add to appeals and uncheck the ones you wish to remove."
                  acceptLabel="OK"
                  (cancel)="cancel()"
                  (save)="save()"
                  [disableSave]="!hasChanges">

    <div class="ws-flex-container-horizontal ws-flex-align-items-center" style="margin-bottom: 10px;">
        <div class="ws-flex-none">Apply changes to:</div>
        <div class="ws-flex-none" style="padding-left: 8px;">
            <select class="form-select form-select-sm"
                    [(ngModel)]="selectedApplyChangesScopeOption"
                    (change)="onSelectedApplyChangesScopeFilterChange()">
                @for (item of applyChangesScopeOptions; track item) {
                    <option [ngValue]="item">{{ item.value }}</option>
                }
            </select>
        </div>
    </div>
    @if (!formRevisionAssociations.length && !isBusy) {
        <span>There are no supplemental appeals available.</span>
    }
    @if (formRevisionAssociations.length) {
        <table class="table table-condensed">
            <tbody>
                @for (item of formRevisionAssociations; track item) {
                    <tr>
                        <td class="col-lg-1">
                            <label class="small">
                                <input type="checkbox"
                                       [ngModel]="item.isAssociated"
                                       (ngModelChange)="onFormSelectedChange(item)">
                            </label>
                        </td>
                        <td class="col-lg-1">{{ item.name }}</td>
                        <td class="col-lg-8" [ngClass]="{ 'text-success': item.hasChanges && item.isSelected === true, 'text-danger': item.hasChanges && item.isSelected === false }">{{ getMessage(item) }}</td>
                    </tr>
                }
            </tbody>
        </table>
    }
</ws-modal-wrapper>
